import { formatDistanceStrict } from 'date-fns';

/**
 * Converts a UNIX timestamp (in seconds) into a short, human-readable date string.
 *
 * - Expects seconds (not milliseconds) and converts internally.
 * - Returns the first 24 characters of `Date.toString()`
 *   (e.g., "Tue Jan 23 2024 14:37:05").
 * - Locale- and timezone-dependent.
 * - For display only (not parsing or sorting).
 */
export const getShortDateString = (date: number): string => {
  const dateObj = new Date(date * 1000);
  const dateString = dateObj.toString();
  return dateString.slice(0, 24);
};

/**
 * Returns the exact time difference between two ISO date strings
 * as a human-readable duration (e.g., "3 days", "2 hours").
 *
 * - Uses current time if `endDate` is not provided.
 * - Based on date-fns `formatDistanceStrict` (no "ago" suffix).
 */
export const getProcessingTime = (startDate: string, endDate?: string): string => {
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : new Date();

  return formatDistanceStrict(end, start);
};
